import { render, staticRenderFns } from "./RegisterKomship.html?vue&type=template&id=41b64dc6&scoped=true&"
import script from "./RegisterKomship.js?vue&type=script&lang=js&"
export * from "./RegisterKomship.js?vue&type=script&lang=js&"
import style0 from "./RegisterKomship.css?vue&type=style&index=0&id=41b64dc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b64dc6",
  null
  
)

export default component.exports